import { render, staticRenderFns } from "./providerList.vue?vue&type=template&id=2c80f647&scoped=true"
import script from "./providerList.vue?vue&type=script&lang=js"
export * from "./providerList.vue?vue&type=script&lang=js"
import style0 from "./providerList.vue?vue&type=style&index=0&id=2c80f647&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c80f647",
  null
  
)

export default component.exports